import { IAllApplicantData, IApplicant } from "../Applicants/ApplicantsModel";

export const getChipColor = (jobStage: string) => {
    switch (jobStage.toLowerCase()) {
      case "hired":
        return "#28549c";
      case "offer":
        return "#f0648c";
      case "second_interview":
        return "#089484";
      default:
        return "#089484";
    }
  };

export const talentPoolSections = [
    { label: "Hired Stage", stage: "hired" },
    { label: "Offer Stage", stage: "offer" },
    { label: "Final Interview", stage: "second_interview" },
    { label: "Interview", stage: "interview" },
    { label: "Phone Screening", stage: "phone_screening" },
    { label: "New Stage", stage: "new" },
    { label: "Rejected Stage", stage: "rejected" },
  ];

export const getJobData = (applicant: IAllApplicantData) => ({
    id: applicant.employerjob.id,
    name: applicant.employerjob.name || "", 
    jobState: "ACTIVE",
    city: "",
    hiring_manager: "",
    newCandidateCount: 0,
    owner: "",
    state: "",
    starts_at: "",
    ends: "",
    new_candidates_count: 0,
    isExpanded: undefined,
    getJobDescStatus: "idle",
    getJobDescResponse: "",
    jobDetails: undefined,
    new_stage_count: undefined,
  });

  export const mapApplicantToIApplicant = (applicant: any): IApplicant => {
    return {
      applicationCompletedAt: applicant.applicationCompletedAt || "",
      atsPurchased: applicant.atsPurchased || false,
      candidateEmployerJobId: applicant.candidateEmployerJobId || 0,
      candidateId: applicant.candidate.id || 0,
      commentTotal: applicant.commentTotal || 0,
      distortionCount: applicant.distortionCount || 0,
      email: applicant.candidate.account.email || "",
      employerJobId: applicant.employerjob?.id || 0,
      firstName: applicant.candidate.account.first_name || "",
      jobStage: applicant.stage || "not_set", 
      stageModifiedAt: new Date(applicant.stageModifiedAt || Date.now()),
      lastName: applicant.candidate.account.last_name || "",
      matchType: applicant.final_match || "unknown",
      resumeScore: applicant.resume_match_score || 0,
      rating: applicant.rating || 0,
      isExpanded: applicant.isExpanded,
      changeStateStatus: applicant.changeStateStatus,
      changeStateResponse: applicant.changeStateResponse,
      updateRatingStatus: applicant.updateRatingStatus,
      updateRatingResponse: applicant.updateRatingResponse,
      fullName: `${applicant.candidate.account.first_name} ${applicant.candidate.account.last_name}`,
      hasReceivedInterviewEmail: applicant.hasReceivedInterviewEmail,
      hasReceivedOfferLetterEmail: applicant.hasReceivedOfferLetterEmail,
      hasReceivedRejectionEmail: applicant.hasReceivedRejectionEmail,
      addedRejectionReasons: applicant.addedRejectionReasons,
      resumeId: applicant.resume_id,

    };
  };
